var React = require('react');

function StreamlineLine18NewDocumentText (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M15.5 15.5v8H.5V.5h23v15zM23.5 15.5l-8 8","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"M5 10l1-1c.553-.552 1.447-.552 2 0 .553.553 1.447.553 2 0 .553-.552 1.447-.552 2 0 .553.553 1.447.553 2 0 .553-.552 1.447-.552 2 0 .553.553 1.447.553 2 0l1-1M5 15l1-1c.553-.552 1.447-.552 2 0 .553.553 1.447.553 2 0","key":1})]),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine18NewDocumentText.displayName = "StreamlineLine18NewDocumentText";

StreamlineLine18NewDocumentText.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine18NewDocumentText;

StreamlineLine18NewDocumentText.default = StreamlineLine18NewDocumentText;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-18-new-document-text.svg
// module id = 769
// module chunks = 0